// AI Trading constants and mock data
export const MOCK_TOKENS = ['ETH', 'BTC', 'LINK', 'UNI', 'AAVE'];

export const TRADING_STRATEGIES = [
  'Technical Analysis',
  'Sentiment Analysis', 
  'Arbitrage Detection',
  'Mean Reversion',
  'Momentum Trading',
  'AI Pattern Recognition'
];

export const TIMEFRAMES = ['1h', '4h', '1d', '1w', '1M'];

export const RISK_LEVELS = ['low', 'medium', 'high', 'critical'] as const;

export const SIGNAL_TYPES = ['buy', 'sell', 'hold'] as const;

export const DEFAULT_PORTFOLIO_ASSETS = [
  {
    symbol: 'ETH',
    name: 'Ethereum',
    balance: 5.234,
    usdValue: 14567.89,
    change24h: 2.45,
    allocation: 45.2,
    chain: 'ethereum',
    type: 'token' as const
  },
  {
    symbol: 'BTC', 
    name: 'Bitcoin',
    balance: 0.456,
    usdValue: 30234.56,
    change24h: 1.87,
    allocation: 38.7,
    chain: 'bitcoin',
    type: 'token' as const
  },
  {
    symbol: 'LINK',
    name: 'Chainlink', 
    balance: 234.67,
    usdValue: 3456.78,
    change24h: -1.23,
    allocation: 10.5,
    chain: 'ethereum',
    type: 'token' as const
  }
];

export const AI_FEATURES = {
  SENTIMENT_ANALYSIS: 'sentiment',
  PRICE_PREDICTION: 'prediction',
  ARBITRAGE_DETECTION: 'arbitrage',
  PORTFOLIO_OPTIMIZATION: 'optimization',
  RISK_ASSESSMENT: 'risk',
  AUTO_TRADING: 'auto_trading'
} as const;

export const CHART_COLORS = {
  PRIMARY: '#8884d8',
  SECONDARY: '#82ca9d', 
  TERTIARY: '#ffc658',
  QUATERNARY: '#ff7300',
  SUCCESS: '#22c55e',
  WARNING: '#eab308',
  ERROR: '#ef4444',
  INFO: '#3b82f6'
};